export default (...segments: string[]) => {
	let leadingSlash = segments.length && segments[0].startsWith('/')
	const url = segments.reduce((cleanedSegments, segment) => {
		if (segment) {
			// Remove leading/trailing slashes in a segment to check if the segment actually contains a value.
			const sanitizedSegment = segment.trim().replace(/(^\/|\/$)/g, '')
			if (sanitizedSegment) {
				// Check if the segment contais a protocol. This is to support absolute urls.
				if (/^\w+:\/\//.test(sanitizedSegment)) {
					leadingSlash = false
					return [sanitizedSegment]
				}
				cleanedSegments.push(sanitizedSegment)
			}
		}
		return cleanedSegments
	}, [] as string[])

	const finalUrl = url.join('/')
	const trailingSlash = segments.length && segments[segments.length - 1].trim().endsWith('/')
	if (!finalUrl) {
		if (leadingSlash || trailingSlash) {
			return '/'
		}
		return finalUrl
	}

	return `${leadingSlash ? '/' : ''}${finalUrl}${trailingSlash ? '/' : ''}`
}
